import css from "./MessageButtonList.module.scss";

import React, { HTMLAttributes, useEffect, useState } from "react";
import { classNames } from "@greeter/util";

export type MessageButtonListProps = HTMLAttributes<HTMLDivElement> & {};

export const MessageButtonList: React.FC<MessageButtonListProps> = ({
  className,
  ...props
}) => {
  return <div {...props} {...classNames(css.MessageButtonList, className)} />;
};

